export default __webpack_public_path__ + "static/media/office10small.f66fc71b.jpg";